import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromDeliveryReducer from '../reducers/delivery.reducer';
import * as fromOfflineSelectors from './offline.selectors';
import { Delivery } from '../../models';

export const selectDelivery = createFeatureSelector<fromDeliveryReducer.DeliveryState>('delivery');

export const getDeliveryData = createSelector(
  selectDelivery,
  fromOfflineSelectors.selectOfflineDeliveries,
  (deliveryState: any, offlineDeliveryies: Delivery[]) => {
    const delivery = { ...deliveryState.data };
    let cachedDelivery;
    if (delivery) {
      cachedDelivery =
        offlineDeliveryies &&
        offlineDeliveryies.find(
          (oDelivery: Delivery) => oDelivery.deliveryKeyCode === delivery.deliveryKeyCode,
        );
    }
    delivery.offlineStatus = cachedDelivery ? cachedDelivery.offlineStatus : 'readyToDownload';
    return delivery;
  },
);

export const getDeliveryLoading = createSelector(selectDelivery, fromDeliveryReducer.selectLoading);
export const getDeliveryLoaded = createSelector(selectDelivery, fromDeliveryReducer.selectLoaded);
export const getAssetGroup = createSelector(selectDelivery, fromDeliveryReducer.selectAssetsGroup);
